import { createPortal } from "react-dom";

/**
 * Full-screen blocking overlay with a spinner. While `show` is true it covers
 * the whole page and captures every pointer event, so nothing underneath can be
 * clicked. Rendered into <body> so it sits above all content and modals.
 *
 * Drive it with useBusy: <BusyOverlay show={busy} label="Saving…" />
 */
export default function BusyOverlay({ show, label }) {
  if (!show) return null;
  return createPortal(
    <div className="busy-overlay" role="alert" aria-busy="true">
      <div className="busy-spinner" aria-hidden="true" />
      {label ? <div className="busy-label">{label}</div> : null}
    </div>,
    document.body
  );
}
